import React from "react";

export default function PrimaryButton({
  text,
  subText,
  handleClick,
  disabled,
  error,
  color,
  loading,
  icon: Icon,
}) {
  return (
    <div className="w-full flex flex-col gap-2">
      {error && (
        <div className="w-full p-1 px-4 bg-red-400/10 text-red-400 rounded-xl text-xs">
          {error}
        </div>
      )}
      <button
        disabled={disabled || loading}
        type="button"
        className={`flex flex-col text-black bg-primary-100 font-semibold rounded-full text-base px-5 py-2.5 text-center ${color} w-full disabled:opacity-45 h-14 flex items-center justify-center`}
        onClick={handleClick}
      >
        {loading && (
          <span className="absolute inset-0 flex items-center justify-center">
            <svg
              className="w-6 h-6 text-white animate-spin"
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <circle cx="12" cy="12" r="10" />
              <path d="M4 12a8 8 0 0 1 16 0 8 8 0 0 1-16 0" />
            </svg>
          </span>
        )}
        <span className="flex items-center gap-1">
          {text}
          {!loading && Icon && <Icon className="w-5 h-5" />}
        </span>
        {subText && (
          <span className="flex items-center gap-2 text-3xs">{subText}</span>
        )}
      </button>
    </div>
  );
}
